import type React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentProject } from "~/slices/auth";
import type { RootState } from "~/store";
import Button from "../button";
import Modal from "../modal";
import styles from "./index.module.scss";

interface CreditLackModalProps {
  lackCredit: number;
  isOpen: boolean;
  onClose: () => void;
}

const CreditLackModal: React.FC<CreditLackModalProps> = ({ lackCredit, isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, organization } = useSelector((state: RootState) => state.auth);
  // フリープランはバックエンドでクレジット購入を受け付けないため、購入導線を出さない
  const isFreePlan = organization?.plan?.type === "free";
  const canGuideToPurchase = currentUser?.role === "admin" && !isFreePlan;

  const handleAction = async () => {
    try {
      if (canGuideToPurchase && currentUser?.organization_id) {
        // プロジェクト選択を解除
        dispatch(setCurrentProject(null));
        navigate(`/${currentUser.organization_id}/billings?tab=overview`);
      }
      onClose();
    } catch (error) {
      console.error("Error handling action:", error);
    }
  };

  return (
    <Modal
      label="クレジット不足のため生成できません"
      isOpen={isOpen}
      onClose={onClose}
      content={
        <div className={styles["modalContent"]}>
          <p>
            生成クレジットが{lackCredit}クレジット不足しているため、生成できませんでした。
            <br />
            {isFreePlan
              ? "フリープランではクレジットを購入できません。"
              : canGuideToPurchase
                ? "「支払いとプラン」へ移動してクレジットを購入してください。"
                : "管理者にクレジットを購入してもらうように依頼してください。"}
          </p>
          <div className={styles["buttonContainer"]}>
            {canGuideToPurchase && (
              <Button styleType="white-middle" label={"キャンセル"} onClick={onClose} />
            )}
            <Button
              styleType="blue-middle"
              label={canGuideToPurchase ? "購入ページへ" : "OK"}
              onClick={handleAction}
            />
          </div>
        </div>
      }
    />
  );
};

export default CreditLackModal;
